import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/**
 * One shared listener set for the whole authentication journey, from password entry through second
 * factor enrollment: `eventName` matches the `type` of the actions dispatched by `login`,
 * `verifySecondFactor`, `confirmSecondFactorEnrollment`, `resolveAuthenticationModes` and
 * `startSsoAuthentication`. Mounted by each screen it concerns — the routes are mutually exclusive,
 * so only one instance is ever active at a time.
 *
 * `AUTHENTICATION_FAILED` fires both on a `401` (empty body, `payload` is `undefined`) and on a
 * `403` (`payload.message` set by the server — locked or disabled account). The static `message`
 * below is therefore the generic wording for the `401` case; the server's own wording takes
 * priority whenever it is present.
 */
const AuthenticationNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<ErrorNotification
				eventName="AUTHENTICATION_FAILED"
				title="Connexion impossible"
				message="L’adresse e-mail ou le mot de passe est incorrect."
			/>
			<ErrorNotification
				eventName="SECOND_FACTOR_VERIFICATION_FAILED"
				title="Vérification impossible"
				message="Le code est invalide."
			/>
			<ErrorNotification
				eventName="SECOND_FACTOR_ENROLLMENT_FAILED"
				title="Activation impossible"
				message="Le code est invalide."
			/>
			<SuccessNotification
				eventName="SECOND_FACTOR_ENROLLED"
				title="Second facteur activé"
				message="La double authentification est maintenant active sur votre compte."
			/>
			<ErrorNotification
				eventName="AUTHENTICATION_MODES_RESOLUTION_FAILED"
				title="Vérification impossible"
				message="Impossible de vérifier les modes de connexion disponibles pour cette adresse. Vous pouvez continuer avec votre mot de passe."
			/>
			<ErrorNotification
				eventName="SSO_AUTHENTICATION_START_FAILED"
				title="Connexion impossible"
				message="Le démarrage de la connexion avec le fournisseur d’identité a échoué."
			/>
		</React.Fragment>
	);
};

export default AuthenticationNotifications;
